/** WhatsApp-style green unread counter badge. */
export const ChatBadge = ({ count, className = "", testId = "chat-unread-badge" }) => {
  if (!count || count <= 0) return null;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-[#25D366] text-white text-[10px] font-extrabold leading-none shadow-[0_0_8px_rgba(37,211,102,0.5)] ${className}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};
